var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/DynamicGroup/DynamicGroup.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { ApiDomain } from '../../domain';
import { DynamicBaseGroup } from './DynamicBaseGroup';
import { DynamicGeneratedGroup } from './DynamicGeneratedGroup';
import { DynamicGroupStatus } from './DynamicGroupStatus';
import { DynamicGroupCondition } from './DynamicGroupCondition';
export var DynamicGroup;

(function (_DynamicGroup) {
  var domain = ApiDomain.domain('DynamicGroup', {
    name: "domain",
    sid: "jpxvmh"
  });
  var io = _DynamicGroup.io = t.recursion('DynamicGroup', function () {
    return t.union([DynamicBaseGroup.io, DynamicGeneratedGroup.io]);
  });
  var Populated;

  (function (_Populated) {
    var io = _Populated.io = t.recursion('Populated', function () {
      return t.union([DynamicBaseGroup.Populated.io, DynamicGeneratedGroup.Populated.io]);
    });
  })(Populated || (Populated = _DynamicGroup.Populated || (_DynamicGroup.Populated = {})));

  var create = _DynamicGroup.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: t.recursion('DynamicGroupCondition', function () {
      return DynamicGroupCondition.Data;
    }),
    getKey: ['classifierId', 'sourceGroupId']
  });
  var fetch = _DynamicGroup.fetch = ApiCallService.create({
    name: 'fetch',
    parentDomain: domain,
    result: Populated.io,
    getKey: ['classifierId', 'dynamicGroupId', 'version']
  });
  var updateCondition = _DynamicGroup.updateCondition = ApiCallService.create({
    name: 'updateCondition',
    parentDomain: domain,
    result: t.recursion('DynamicBaseGroup', function () {
      return DynamicBaseGroup.io;
    }),
    getKey: ['classifierId', 'dynamicGroupId', 'version']
  });
  var remove = _DynamicGroup.remove = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: t.recursion('DynamicBaseGroup', function () {
      return DynamicGroupCondition.Data;
    }),
    getKey: ['classifierId', 'sourceGroupId']
  });
  var start = _DynamicGroup.start = ApiCallService.create({
    name: 'start',
    parentDomain: domain,
    result: t.recursion('DynamicGroupStatus', function () {
      return DynamicGroupStatus.Data;
    }),
    getKey: ['classifierId', 'version']
  });
  var status = _DynamicGroup.status = ApiCallService.create({
    name: 'status',
    parentDomain: domain,
    result: t.recursion('DynamicGroupStatus', function () {
      return DynamicGroupStatus.Data;
    }),
    getKey: ['classifierId', 'version']
  });
})(DynamicGroup || (DynamicGroup = {}));